// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__Dv1tf","icon":"Icon_icon__pBR1C"};